import React, { useState, useEffect } from "react";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import "./Modal.css";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import { changePassword } from "../Store/Actions/AuthAction";
import { toast } from "react-toastify";

const ChangePassModal = ({ ChangeCompletePass, onClose }) => {
  const [activeConfirm, setActiveConfirm] = useState(false);
  const PWD_REGEX = /^......../;

  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [showPassword3, setShowPassword3] = useState(false);
  const handleClickShowPassword1 = () => setShowPassword1(!showPassword1);
  const handleClickShowPassword2 = () => setShowPassword2(!showPassword2);
  const handleClickShowPassword3 = () => setShowPassword3(!showPassword3);
  const [OldpwdInput, setTextInputOld] = useState("");
  const [pwdInput, setTextInput] = useState("");
  const [pwdInput2, setTextInput2] = useState("");
  const [activeButton, setActiveButton] = useState(false);

  const buttonActionPass = async (OldpwdInput, pwdInput, pwdInput2) => {
    const response = await changePassword(OldpwdInput, pwdInput, pwdInput2);
    if (response.status) {
      toast.success(response.data);
      setActiveConfirm(false);
      onClose();
    } else toast.warn(response.error);
  };

  useEffect(() => {
    const ValidPwd = PWD_REGEX.test(pwdInput);
    if (ValidPwd && pwdInput === pwdInput2) {
      setActiveButton(true);
    } else {
      setActiveButton(false);
    }
  });

  useEffect(() => {
    if (ChangeCompletePass) {
      setActiveConfirm(true);
    }
  }, [ChangeCompletePass]);

  return (
    <div className="overlayHistory">
      {activeConfirm === true ? (
        <div className="confirmationChange">
          <div className="modalContainerConfirmation">
            <div className="containerINmodal">
              <span>Your Password has changed</span>
              <button>
                <span>Confirm</span>
              </button>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className="modalContainer"
      >
        <div className="modalRight">
          <CloseOutlinedIcon
            className="closeBtn"
            onClick={onClose}
          ></CloseOutlinedIcon>
          <div className="content">
            <h1>Change Password</h1>
          </div>
          <div className="changePass">
            <ul>
              <li>
                <TextField
                  label="Old Password"
                  variant="outlined"
                  value={OldpwdInput}
                  type={showPassword1 ? "text" : "password"}
                  onChange={(event) => {
                    setTextInputOld(event.target.value);
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword1}
                        >
                          {showPassword1 ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  sx={{ width: 300 }}
                />
              </li>
              <li>
                <TextField
                  label="Password"
                  variant="outlined"
                  value={pwdInput}
                  type={showPassword2 ? "text" : "password"}
                  onChange={(event) => {
                    setTextInput(event.target.value);
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword2}
                        >
                          {showPassword2 ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  sx={{ width: 300 }}
                />
              </li>
              <li>
                <TextField
                  label="Re-Enter Password"
                  variant="outlined"
                  value={pwdInput2}
                  type={showPassword3 ? "text" : "password"}
                  onChange={(event) => {
                    setTextInput2(event.target.value);
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword3}
                        >
                          {showPassword3 ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  sx={{ width: 300 }}
                />
              </li>
            </ul>
          </div>
          <div className="btnContainer">
            <button className="btn_Cancel" onClick={onClose}>
              Cancel
            </button>
            <button
              className={activeButton ? "btn_Confirm" : "btn_Confirm_deactive"}
              onClick={() => buttonActionPass(OldpwdInput, pwdInput, pwdInput2)}
              disabled={!activeButton}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassModal;
